import React from 'react'

import { VideoBackgroundProps } from '../types'

/**
 * VideoBackground - Renders a standard HTML5 video background
 */
export const VideoBackground = React.memo(({ videoSrc, layerStyle, index }: Omit<VideoBackgroundProps, 'values'>) => (
  <div style={{ ...layerStyle, zIndex: -index - 1 }}>
    <video
      autoPlay
      muted
      loop
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <source src={videoSrc} type='video/mp4' />
      Your browser does not support the video tag.
    </video>
  </div>
))
VideoBackground.displayName = 'VideoBackground'
